// use-create-team.ts — Teams suite, action
//
// Creates a new team. Invalidates the teams list on success.

'use client';

import { useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import type { CreateTeamRequest, CreateTeamResponse } from '@cabal/shared/domain/session/team/types.js';
import { useApi } from '@/contexts/api';
import { useActionHook } from '@/lib/query/use-action-hook';
import type { ActionResult } from '@/types/async-protocol';
import { teamsRootKey } from './team-query-keys';

export function useCreateTeam(): ActionResult<CreateTeamRequest, CreateTeamResponse> {
  const api = useApi();
  const queryClient = useQueryClient();

  return useActionHook<CreateTeamRequest, CreateTeamResponse>(
    useMemo(
      () => ({
        mutationFn: (request) => api.teams.create({ body: request }),
        onInvalidate: () => {
          queryClient.invalidateQueries({ queryKey: teamsRootKey });
        },
      }),
      [api, queryClient],
    ),
  );
}
